<template>
  <GBox class="holiday-mode-wrapper">
    <GBox v-if="!editable">
      <GText>
        Tatil modu işlemleri 20 Mayıs tarihine kadar
        <RouterLink
          to="/account/info?tab=workingModeSettings"
          class="sc-link"
        >
          Covid-19 Çalışma Durumu
        </RouterLink> ekranlarından yönetilecektir.
      </GText>
    </GBox>
    <template v-else>
      <GAlert
        variant="warning"
        icon-size="36px"
      >
        <GText
          variant="subtitle-03"
          color="orange-500"
        >
          Tatil modu özelliğiyle birlikte;
        </GText>
        <ul class="list">
          <li>
            <GText
              variant="body"
              color="orange-500"
            >
              Güncel fiyat ve stok bilgilerinizi koruyarak tüm ürünlerinizin satışını durdurabilir, istediğiniz zaman aynı fiyat ve stok bilgileri ile tekrar yayına alabilirsiniz.
            </GText>
          </li>
          <li>
            <GText
              variant="body"
              color="orange-500"
            >
              Tatil Modu devreye alma ve kapama işlemi <strong>24 saat</strong> içerisinde maksimum <strong>1 kez</strong> yapılabilecektir.
            </GText>
          </li>
          <li>
            <GText
              variant="body"
              color="orange-500"
            >
              Tatil Modu devreye alındığında satış ve Trendyol içi sıralama kaybı yaşayabilirsiniz.
            </GText>
          </li>
        </ul>
      </GAlert>
      <GBox
        class="left"
        :mt="30"
      >
        <GBox
          flex
          :mt="3"
        >
          <GBox
            class="setting"
            flex
            align="items-center"
            justify="space-between"
          >
            <GText variant="subtitle-03">
              TATİL MODU
            </GText>
            <GBox
              flex
              align="center"
            >
              <GSwitch
                size="medium"
                @input="onHolidaySetting"
                v-model="settings.holidayMode"
              />
              <GText
                class="subtext g-ml-12"
                variant="body"
              >
                {{ settings.holidayMode ? 'Açık': 'Kapalı' }}
              </GText>
            </GBox>
          </GBox>
        </GBox>
      </GBox>
      <ConfirmDialog
        :show="showConfirmationModal"
        :dialog-as-html="modalBody"
        @close="onConfirmCancel"
        @confirm="updateHolidayModeSetting"
      />
    </template>
  </GBox>
</template>

<script>
import account from '@/services/account';
import ConfirmDialog from '@/components/Confirmation/Index';
import GText from '@trendyol-js/grace/core/GText';
import GBox from '@trendyol-js/grace/core/GBox';
import GSwitch from '@trendyol-js/grace/core/GSwitch';
import GAlert from '@trendyol-js/grace/core/GAlert';
import { remoteConfig } from '@/services';

export default {
  name: 'HolidayModeSettings',
  components: {
    ConfirmDialog,
    GText,
    GBox,
    GSwitch,
    GAlert,
  },
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      settings: {
        holidayMode: false,
      },
      modalTexts: {
        enableHolidayMode: `<h6>Tatil Modu'nu devreye almanız halinde satışınız durdurulacaktır.
          Tatil Modu'nu devre dışı bırakmanız durumunda ürünleriniz paneldeki fiyat ve stok bilgileri
          ile tekrar yayına alınacaktır.</h6>
            <hr>
          <u>Önemli Not:</u><br><br>
          • Tatil Modu'nu devreye almanız durumunda tekrar devre dışı bırakmak için <b>24 saat</b> beklemeniz gerekmektedir.<br><br>
          • Tatil Modu devreye alındıktan sonra ürünleriniz <b>1 saat</b> içinde satışa kapanacaktır.<br><br>
          • Tatil Modu devreye alındığında satış ve Trendyol içi sıralama kaybı yaşayabilirsiniz.<br>`,
        disableHolidayMode: `<h6>Tatil Modu'nu devre dışı bırakmanız durumunda ürünleriniz paneldeki fiyat ve
          stok bilgileri ile tekrar satışa açılacaktır, ilerlemek istediğinizden emin misiniz?</h6>
            <hr>
          <u>Önemli Not:</u><br><br>
          • Tatil Modu'nu devre dışı bırakmanız durumunda tekrar devreye almak için <b>24 saat</b> beklemeniz gerekmektedir.<br><br>
          • Tatil Modu'nu  devre dışı bıraktıktan sonra ürünleriniz <br>1 saat</b> içinde satışa açılacaktır.<br>
          `,
      },
      showConfirmationModal: false,
      modalBody: '',
    };
  },

  computed: {
    isNewSellerApi () {
      return remoteConfig.getConfigValueByKey('IS_NEW_SELLER_API', false);
    },
  },
  methods: {
    async getHolidayModeSetting () {
      this.settings.holidayMode = await account.getHolidaySetting();
    },
    async updateHolidayModeSetting () {
      if (this.isNewSellerApi) {
        await account.updateHolidaySettingV2({
          holidayModeEnabled: this.settings.holidayMode,
        });
      } else {
        await account.updateHolidaySetting({
          holidayModeEnabled: this.settings.holidayMode,
        });
      }

      this.showConfirmationModal = false;

      this.$toast.success('İşleminiz başarılı.', {
        duration: 5000,
      });
    },
    onHolidaySetting (value) {
      if (value) {
        this.modalBody = this.modalTexts.enableHolidayMode;
      } else {
        this.modalBody = this.modalTexts.disableHolidayMode;
      }

      this.showConfirmationModal = true;
    },
    onConfirmCancel () {
      this.showConfirmationModal = false;
      this.settings.holidayMode = !this.settings.holidayMode;
    },
  },
  created () {
    if (this.editable) {
      this.getHolidayModeSetting();
    }
  },
};
</script>
<style scoped lang="scss">
  @import "~@trendyol-js/grace/css/system";

  .holiday-mode-wrapper {
    .left {
      width: 35%;

      .setting {
        width: 100%;
      }
    }

    .list {
      list-style: disc;
      margin-left: 15px;

      li {
        margin: 7px 0;
      }
    }

    ::v-deep .g-alert .content {
      font-weight: unset;
    }
  }

  ::v-deep .modal-dialog {
    max-height: unset !important;
  }

  b, strong {
    font-weight: bold !important;
  }
</style>
